import { Action } from '@ngrx/store';
import { SummaryBankAccountModel } from '../../models/summary-bank-account.model';

export enum BankAccountActionTypes {
  LoadBankAccounts = '[BankAccountV2] Load',
  LoadBankAccountsSuccess = '[BankAccountV2] Load Success',
  LoadBankAccountsFailure = '[BankAccountV2] Load Failure',
}

export class LoadBankAccounts implements Action {
  readonly type = BankAccountActionTypes.LoadBankAccounts;
  constructor(public payload: { filter: any }) {}
}

export class LoadBankAccountsSuccess implements Action {
  readonly type = BankAccountActionTypes.LoadBankAccountsSuccess;
  constructor(public payload: { items: SummaryBankAccountModel[]; total: number }) {}
}

export class LoadBankAccountsFailure implements Action {
  readonly type = BankAccountActionTypes.LoadBankAccountsFailure;
  constructor(public payload: { error: any }) {}
}

export type BankAccountActions =
  | LoadBankAccounts
  | LoadBankAccountsSuccess
  | LoadBankAccountsFailure;
